import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import toast from 'utils/toast.jsx';
import { closeModal, openModal } from 'features/utilsSlice';
import IconMainContainer from 'components/IconMainContainer';

const useWishlistCheckoutSuccess = () => {
  const dispatch = useDispatch();

  const handleSuccess = useCallback(() => {
    dispatch(closeModal('Payment'));
    dispatch(closeModal('Wish Checkout'));
    dispatch(openModal({ name: 'Wish Payment Success' }));

    toast('success', 'Your order has been placed successfully!', {
      icon: <IconMainContainer src="/icons/notifications/thumb-up.svg" alt="Thumb Up" />,
    });
  }, [dispatch]);

  return handleSuccess;
};

export default useWishlistCheckoutSuccess;
